var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { provide } from '@lit/context';
import { QueryClient } from '@tanstack/query-core';
import { QueryContext } from './context.js';
/**
 * Query Client Context as mixin class.
 * Extend this mixin class to make any LitElement class a context provider.
 *
 * @param Base - The base class to extend. Must be or inherit LitElement.
 * @returns Class extended with query client context provider property.
 */
export const QueryClientMixin = (Base) => {
    class QueryClientContextProvider extends Base {
        constructor() {
            super(...arguments);
            /**
             * The query client provided as a context.
             * May be overridden to set a custom configuration.
             */
            this.queryClient = new QueryClient();
        }
        connectedCallback() {
            super.connectedCallback();
            this.queryClient.mount();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.queryClient.unmount();
        }
    }
    __decorate([
        provide({ context: QueryContext }),
        state()
    ], QueryClientContextProvider.prototype, "queryClient", void 0);
    // Cast return type to the mixin's interface intersected with the Base type
    return QueryClientContextProvider;
};
/**
 * Query client context provided as a Custom Component.
 * Place any components that should use the query client context as children.
 */
let QueryClientProvider = class QueryClientProvider extends QueryClientMixin(LitElement) {
    render() {
        return html `<slot></slot>`;
    }
};
QueryClientProvider = __decorate([
    customElement('query-client-provider')
], QueryClientProvider);
export { QueryClientProvider };
